import React from 'react';
import { Box, Stack, Grid, Paper, Skeleton } from '@mui/material';

export const DetailedResultsSkeleton: React.FC = () => {
  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 8rem)', overflowY: 'auto', p: 2 }}>
      {/* Candidate Info Card Skeleton */}
      <Paper variant="outlined" sx={{ p: 2, mb: 3, borderRadius: 2.5 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="25%" height={24} />
            <Skeleton variant="text" width="35%" height={18} />
          </Box>
          <Box sx={{ textAlign: 'right' }}>
            <Skeleton variant="text" width={80} height={18} />
            <Skeleton variant="text" width={60} height={14} />
          </Box>
        </Stack>
      </Paper>

      {/* Skills Assessment Header Skeleton */}
      <Box sx={{ mb: 3 }}>
        <Paper variant="outlined" sx={{ p: 1.5, mb: 2, borderRadius: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Skeleton variant="rounded" width={28} height={28} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width={120} height={20} />
              <Skeleton variant="text" width={60} height={14} />
            </Box>
          </Stack>
        </Paper>

        {/* Skills Grid Skeleton */}
        <Grid container spacing={2}>
          {[1, 2, 3].map((i) => (
            <Grid item xs={12} md={4} key={i}>
              <Paper
                variant="outlined"
                sx={{ p: 2, borderRadius: 2, height: 120, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
              >
                <Box>
                  <Skeleton variant="text" width="75%" height={20} />
                  <Skeleton variant="text" width="50%" height={16} />
                </Box>
                <Stack direction="row" spacing={1}>
                  <Skeleton variant="text" width="50%" height={16} />
                  <Skeleton variant="text" width="50%" height={16} />
                </Stack>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Behavioral Interview Header Skeleton */}
      <Box sx={{ mb: 3 }}>
        <Paper variant="outlined" sx={{ p: 1.5, mb: 2, borderRadius: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Skeleton variant="rounded" width={28} height={28} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width={160} height={20} />
              <Skeleton variant="text" width={80} height={14} />
            </Box>
          </Stack>
        </Paper>

        {/* BEI Grid Skeleton */}
        <Grid container spacing={2}>
          {[1, 2, 3].map((i) => (
            <Grid item xs={12} md={4} key={i}>
              <Paper
                variant="outlined"
                sx={{ p: 2, borderRadius: 2, height: 120, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
              >
                <Box>
                  <Skeleton variant="text" width="75%" height={20} />
                  <Skeleton variant="text" width="50%" height={16} />
                </Box>
                <Skeleton variant="text" width="100%" height={16} />
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
